import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQuery';

export const dashboardApi = createApi({
    reducerPath: 'dashboardApi',
    baseQuery: (args, api, extraOptions) => {
        const adjustedArgs = typeof args === 'string' ? `/dashboard${args}` : { ...args, url: `/dashboard${args.url}` };
        return baseQueryWithReauth(adjustedArgs, api, extraOptions);
    },
    tagTypes: ['Menu', 'Pages'],
    endpoints: (builder) => ({
        getMenuStructure: builder.query({
            query: () => '/menu',
            providesTags: ['Menu'],
            transformResponse: (response) => {
                if (response.success) {
                    // Flatten the object structure to an array if needed, or return as is
                    // The component seems to expect an array for rendering
                    return {
                        menu: response.data.menu,
                        permissions: response.data.permissions
                    };
                }
                return { menu: {}, permissions: [] };
            },
        }),
        getAccessiblePages: builder.query({
            query: () => '/pages',
            providesTags: ['Pages'],
            transformResponse: (response) => {
                if (response.success) {
                    return response.data;
                }
                return null;
            },
        }),
        getDashboardStats: builder.query({
            query: () => '/admin',
            transformResponse: (response) => {
                if (response.success) {
                    return response.data;
                }
                return null;
            },
        }),
        getMyDashboard: builder.query({
            query: () => '/me',
            transformResponse: (response) => {
                if (response.success) {
                    return response.data;
                }
                return null;
            },
        }),
    }),
});

export const {
    useGetMenuStructureQuery,
    useGetAccessiblePagesQuery,
    useGetDashboardStatsQuery,
    useGetMyDashboardQuery,
} = dashboardApi;
